module.exports = __webpack_public_path__ + "9f02b8f8.png";